export const PHRASE_MAX = 180;
export const PHRASE_HINT =
  'Serás expulsado si pones "@" o datos de contacto (Instagram, email, teléfono).';

export function hasForbidden(v: string): boolean {
  return /@/.test(v);
}
